/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Actions/NextAction/Content"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let imageCaptureQuestionValueData = fromData.useDataFormat({ viewPath,
context: 'imageCaptureQuestion',
format: fromHelpers.canSkip,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop={0}
 marginLeft={0}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="imageCaptureQuestion"
 format="helpers.js canSkip"
 text={imageCaptureQuestionValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}